import { isMacOs } from '../../helpers/device';

const isMac = isMacOs();

export const HOT_KEY = {
    ESC: 'esc',
    ENTER: 'enter',
    SPACE: 'space',
    ARROW_LEFT: 'arrowleft',
    ARROW_RIGHT: 'arrowright',
    ARROW_UP: 'arrowup',
    ARROW_DOWN: 'arrowdown',

    BACK: isMac ? 'cmd+[' : 'ctrl+[', // Комбинация для навигации назад

    CMD_F: isMac ? 'cmd+f' : 'ctrl+f',
    CMD_B: isMac ? 'cmd+b' : 'ctrl+b',
    CMD_I: isMac ? 'cmd+i' : 'ctrl+i',
    CMD_U: isMac ? 'cmd+u' : 'ctrl+u',
    CMD_S: isMac ? 'cmd+s' : 'ctrl+s',
    CMD_K: isMac ? 'cmd+k' : 'ctrl+k',
    CMD_SHIFT_M: isMac ? 'cmd+shift+m' : 'ctrl+shift+m',
    CMD_SHIFT_F: isMac ? 'cmd+shift+f' : 'ctrl+shift+f',
    CMD_SLASH: isMac ? 'cmd+/' : 'ctrl+/',

    TOGGLE_MICRO: isMac ? 'cmd+d' : 'ctrl+d',
    TOGGLE_CAMERA: isMac ? 'cmd+e' : 'ctrl+e',

    TOGGLE_MEET_STATISTIC: isMac ? ['control+alt+o', 'cmd+alt+o'] : 'ctrl+alt+o',
} as const;

/**
 * Комбинации клавиш, которые имеют дефолтное поведение в браузере
 * и требуют автоматического preventDefault
 */
export const BROWSER_DEFAULT_HOTKEYS = new Set<string>([
    // Cmd/Ctrl комбинации
    'cmd+d',
    'ctrl+d', // Добавить в закладки
    'cmd+e',
    'ctrl+e', // Поиск (в некоторых браузерах)
    'cmd+f',
    'ctrl+f', // Поиск на странице
    'cmd+g',
    'ctrl+g', // Найти следующее
    'cmd+h',
    'ctrl+h', // История
    'cmd+j',
    'ctrl+j', // Загрузки
    'cmd+k',
    'ctrl+k', // Адресная строка (в некоторых браузерах)
    'cmd+l',
    'ctrl+l', // Адресная строка
    'cmd+n',
    'ctrl+n', // Новое окно
    'cmd+o',
    'ctrl+o', // Открыть файл
    'cmd+p',
    'ctrl+p', // Печать
    'cmd+r',
    'ctrl+r', // Обновить страницу
    'cmd+s',
    'ctrl+s', // Сохранить страницу
    'cmd+t',
    'ctrl+t', // Новая вкладка
    'cmd+u',
    'ctrl+u', // Просмотр кода страницы
    'cmd+w',
    'ctrl+w', // Закрыть вкладку
    'cmd+y',
    'ctrl+y', // Повторить
    'cmd+z',
    'ctrl+z', // Отменить
    'cmd+b',
    'ctrl+b', // жирный
    'cmd+i',
    'ctrl+i', // курсив
    'cmd+u',
    'ctrl+u', // подчеркнутый

    // Cmd/Ctrl + Shift комбинации
    'cmd+shift+d',
    'ctrl+shift+d', // Добавить все вкладки в закладки
    'cmd+shift+f',
    'ctrl+shift+f', // Полноэкранный режим
    'cmd+shift+g',
    'ctrl+shift+g', // Найти предыдущее
    'cmd+shift+i',
    'ctrl+shift+i', // DevTools
    'cmd+shift+j',
    'ctrl+shift+j', // DevTools Console
    'cmd+shift+n',
    'ctrl+shift+n', // Новое окно в режиме инкогнито
    'cmd+shift+m',
    'ctrl+shift+m', // Новое окно в режиме инкогнито
    'cmd+shift+r',
    'ctrl+shift+r', // Жесткое обновление страницы
    'cmd+shift+t',
    'ctrl+shift+t', // Восстановить закрытую вкладку
    'cmd+shift+w',
    'ctrl+shift+w', // Закрыть окно
    'cmd+shift+z',
    'ctrl+shift+z', // Повторить

    // Cmd/Ctrl + Alt/Option комбинации
    'cmd+alt+i',
    'ctrl+alt+i', // DevTools (альтернативная комбинация)

    // Функциональные клавиши
    'f1', // Справка
    'f3', // Поиск
    'f5', // Обновить страницу
    'f11', // Полноэкранный режим
    'f12', // DevTools

    // Навигация
    'cmd+[',
    'ctrl+[', // Назад
    'cmd+]',
    'ctrl+]', // Вперед
    'cmd+backspace',
    'ctrl+backspace', // Отключено для предотвращения системных действий

    // Специальные клавиши
    'enter', // Автоматический preventDefault для submit форм shouldSkipEnterInEditableElement
]);

/**
 * Проверяет, требует ли комбинация клавиш автоматического preventDefault
 */
export const shouldPreventDefault = (key: string): boolean => BROWSER_DEFAULT_HOTKEYS.has(key.toLowerCase());

export type HotKeyConstant = string | string[];
